import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import AuthModal from './components/AuthModal'
import { CartProvider } from './context/CartContext'
import { UserProvider } from './context/UserContext'
import './styles/global.css'

createRoot(document.getElementById('root')).render(
  <BrowserRouter>
    <UserProvider>
      <CartProvider>
        <App />
        <AuthModal />
      </CartProvider>
    </UserProvider>
  </BrowserRouter>
)